// extracted by mini-css-extract-plugin
module.exports = {"final-report-uncertain-clinical-significance":"FinalReportUncertainClinicalSignificance_final-report-uncertain-clinical-significance__23mp5"};